module.exports = __webpack_public_path__ + "static/media/4.6fc51ef5.mp3";